module.exports = __webpack_public_path__ + "0c358eaa319defb4f110be7b0a6a0962.avi";